var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100vh","border":"none"}},[(_vm.pdfUrl && !_vm.isLoading)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.viewDraftInvoice == true && _vm.draftInvoice
        ? ("data:application/pdf;base64," + _vm.draftInvoice)
        : _vm.pdfUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }